export const INTERNAL_NETWORK_PATH_NAME = 'internal-networks';

export const INTERNAL_NETWORK_CREDENTIAL_SECRET_MASK =
  '*************************************';

export const INTERNAL_NETWORK_SENSOR_HEARTBEAT_OFFLINE_THRESHOLD_MS = 120_000;

export { INTERNAL_NETWORK_PENTEST_FEATURE_FLAG } from '@terra/shared-authorization';
